'use client'

import { createHash } from 'crypto';

import { useEffect, useRef } from 'react'

import Script from 'next/script'

import { useSession } from 'next-auth/react'

function sha256(text: string): string {
  const hash: string = createHash('sha256')
    .update(text)
    .digest('hex');

  return hash;
}

declare global {
  interface Window {
    gtag?: (...args: any[]) => void
  }
}

const GoogleAnalytics = () => {
  const session = useSession()?.data
  const lastUserIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.gtag &&
      session?.user &&
      session.user.email
    ) {
      const hashedEmail = sha256(session.user.email).toString()

      if (lastUserIdRef.current !== hashedEmail) {
        window.gtag('set', { user_id: hashedEmail })
        console.debug('User ID set to:', hashedEmail)
        lastUserIdRef.current = hashedEmail
      }
    }
  }, [session?.user])

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`}
        strategy="afterInteractive"
      />
      <Script
        id="google-analytics-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}');
          `,
        }}
      />
    </>
  )
}

export default GoogleAnalytics
